import { openAuthModalHandler as openAuthModalHandlerV2 } from '../apiV2/open-auth-modal';
import { setRegionIdHandler as setRegionIdHandlerV2 } from '../apiV2/set-region-id';
import { updateHeaderHandler as updateHeaderHandlerV2 } from '../apiV2/update-header';
import { openAuthModalHandler as openAuthModalHandlerV3 } from '../apiV3/open-auth-modal';
import { setRegionIdHandler as setRegionIdHandlerV3 } from '../apiV3/set-region-id';
import { updateHeaderHandler as updateHeaderHandlerV3 } from '../apiV3/update-header';

import type { TReduxStore } from '../../../shared/types/redux';
import { HEADER_UI_API_PATHS } from './constants';
import type { IHeaderUIAPIController } from './types';

export function createHeaderUIAPIController(store: TReduxStore): IHeaderUIAPIController {
  return {
    methods: {
      [HEADER_UI_API_PATHS.openAuthModalV2]: async parameters => openAuthModalHandlerV2(store, parameters),
      [HEADER_UI_API_PATHS.setRegionIdV2]: async parameters => setRegionIdHandlerV2(store, parameters),
      [HEADER_UI_API_PATHS.updateHeaderV2]: async () => updateHeaderHandlerV2(store),
      [HEADER_UI_API_PATHS.openAuthModalV3]: async parameters => openAuthModalHandlerV3(store, parameters),
      [HEADER_UI_API_PATHS.setRegionIdV3]: async parameters => setRegionIdHandlerV3(store, parameters),
      [HEADER_UI_API_PATHS.updateHeaderV3]: async () => updateHeaderHandlerV3(store),
    },
  };
}
